const HeaderBlock = ({text, level = 2}) => {
    // защита от кривых данных
    const safeLevel = Math.min(Math.max(level, 2), 6);
    const Tag = `h${safeLevel}`;

    return (
        <Tag className={`re-header re-header--h${safeLevel}`}>{text}</Tag>
    );
};

export default HeaderBlock;
